module.exports = __webpack_public_path__ + "img/calories_orange.048049b2.svg";